﻿export class LPXCtrlPoolMngr_v1ABI
{
    public static GetABI():any
    {
        return [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "lpx_",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "controllers",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "lpx",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "manager",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "scale_",
				"type": "uint256"
			}
		],
		"name": "manager_scalePoolLiquidity",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "fundImgReserve_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "anchorImgReserve_",
				"type": "uint256"
			}
		],
		"name": "manager_setPoolImgReserves",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "uint32",
				"name": "ntzIndex_",
				"type": "uint32"
			},
			{
				"internalType": "uint32",
				"name": "profitIndex_",
				"type": "uint32"
			}
		],
		"name": "manager_setPoolIndexes",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "newManager_",
				"type": "address"
			}
		],
		"name": "manager_setPoolManager",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256[]",
				"name": "poolIds_",
				"type": "uint256[]"
			},
			{
				"internalType": "uint8",
				"name": "flag_",
				"type": "uint8"
			},
			{
				"internalType": "bool",
				"name": "value_",
				"type": "bool"
			}
		],
		"name": "manager_setPoolsAccessFlag",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256[]",
				"name": "poolIds_",
				"type": "uint256[]"
			},
			{
				"internalType": "uint8",
				"name": "flag_",
				"type": "uint8"
			},
			{
				"internalType": "bool",
				"name": "value_",
				"type": "bool"
			}
		],
		"name": "manager_setPoolsFlag",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256[]",
				"name": "poolIds_",
				"type": "uint256[]"
			},
			{
				"internalType": "uint8",
				"name": "poolType_",
				"type": "uint8"
			}
		],
		"name": "manager_setPoolsType",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "controllers_",
				"type": "address[]"
			},
			{
				"internalType": "bool",
				"name": "value_",
				"type": "bool"
			}
		],
		"name": "mngr_setControllers",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "manager_",
				"type": "address"
			}
		],
		"name": "mngr_setManager",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"name": "poolsTimestamps",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "version",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];
    }
}
